export default "__VITE_ASSET__WJcoctc6__"